export default __webpack_public_path__ + "static/media/IFW_SoftwarePAGE1ONLY-02.75f4bdb8.png";